import { Banner } from '@/components/ui/banner'
import { listSentence } from '@/lib/formatters'
import {
  AWAITING_CONFIRMATION_REASON,
  type FillApplicationState,
  PickChannel,
} from '@/models/fillApplication'
import { CustomerSignInLink } from './CustomerSignInLink'

/** In place of checkout on the staff Quotes tab while the customer hasn't confirmed their information. */
export function CustomerConfirmationWaiting({
  orgId,
  state,
}: {
  orgId: string
  state: FillApplicationState
}) {
  const pick = state.pendingChannelPick

  return (
    <Banner variant="warning">
      <div className="flex flex-col gap-3">
        <p>
          <strong>{AWAITING_CONFIRMATION_REASON}</strong>
          {pick && (
            <>
              {' '}
              They picked {listSentence(pick.vendors)} by{' '}
              {pick.channel === PickChannel.SMS ? 'text' : 'email'}.
            </>
          )}{' '}
          Checkout opens once they confirm.
        </p>
        <CustomerSignInLink orgId={orgId} link={state.link} />
      </div>
    </Banner>
  )
}
